import React from 'react'
import "../../assets/css/--page-aboutus.css";

export const  ValueCard = ({ image, title }) => {
  return (
    <div className="value-card">
        <img src={image} alt="Value" />
        <h2>{title}</h2>
    </div>
  )
}
